import { EqualValidator } from './equal-validator.directive';
import { NgModule } from '@angular/core';

@NgModule({
  imports: [],
  exports: [EqualValidator],
  declarations: [EqualValidator],
  providers: []
})
export class EqualValidatorModule {}
